import get from 'lodash/get'
import { buildListUrl } from 'utils/url'

const BIG_ASS_CATEGORIES = ['1000', '2000', '4000', '5000', '6000', '7000', '3000', '8000']

const selectCategories = (categories = []) => {
  const sortedCategories = []
  BIG_ASS_CATEGORIES.forEach((cvalue) => {
    const foundCategoy = categories.find(({ value }) => cvalue === value)
    if (foundCategoy) {
      sortedCategories.push(foundCategoy)
    }
  })
  return sortedCategories
}

const getListUrlOptions = (geoPreference) => {
  const { r, m, sa, ag = 0 } = geoPreference || {}
  return {
    ...(r && { r }),
    ...(m && { m }),
    ...(sa && { sa }),
    ...(ag && { ag }),
  }
}

const enrichCategoriesWithUrl = (categories = [], geoPreference, byQueryKey) => {
  const categoriesWithUrl = []

  categories.forEach((category) => {
    const categoryUrl = buildListUrl(
      { cg: category.value, ...getListUrlOptions(geoPreference) },
      byQueryKey,
    )
    let categoryItems = []

    if (category.items) {
      categoryItems = enrichCategoriesWithUrl(category.items, geoPreference, byQueryKey)
    }

    categoriesWithUrl.push({
      ...category,
      url: categoryUrl,
      items: categoryItems,
    })
  })

  return categoriesWithUrl
}

const getBigAssCategories = (byQueryKey, geoPreference) => {
  const selectedCategories = selectCategories(get(byQueryKey, 'cg.items', []))
  const bigAssCategories = enrichCategoriesWithUrl(selectedCategories, geoPreference, byQueryKey)

  return [
    {
      url: buildListUrl(getListUrlOptions(geoPreference), byQueryKey),
      label: 'Alla annonser på Blocket',
      value: '0',
      items: [],
    },
    ...bigAssCategories,
  ]
}

export default getBigAssCategories
